import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { restoreAll } from '../restoreAll';
import { RootState } from '..';
import { PublicUserDto } from '../../commonTypes/user.types';
import { SelectItem } from '../../components/Common/SearchableMultiSelect';

export interface AddEditPolicyState {
    isEdit: boolean;
    organizationMembers: PublicUserDto[];
    selectedMembers: PublicUserDto[];
    selectItems: SelectItem[];
    initialSelectItems: SelectItem[];
    branchItems: SelectItem[];
}

const initialState: AddEditPolicyState = {
    isEdit: false,
    organizationMembers: [],
    selectedMembers: [],
    selectItems: [],
    initialSelectItems: [],
    branchItems: [],
};

type SetOrgMembersAction = PayloadAction<PublicUserDto[]>;
type SetSelectedMembersAction = PayloadAction<PublicUserDto[]>;
type SetSelectItemsAction = PayloadAction<SelectItem[]>;

export const addEditPolicySlice = createSlice({
    name: 'addEditPolicy',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        setOrganizationMembers: (state, action: SetOrgMembersAction) => {
            state.organizationMembers = action.payload;
        },
        setSelectedMembers: (state, action: SetSelectedMembersAction) => {
            state.selectedMembers = action.payload;
        },
        setSelectItems: (state, action: SetSelectItemsAction) => {
            state.selectItems = action.payload;
        },
        setInitialSelectItems: (state, action: SetSelectItemsAction) => {
            state.initialSelectItems = action.payload;
        },
        resetSelectItemsToInit: state => {
            state.selectItems = state.initialSelectItems.map(member => ({ ...member }));
        },
        changeSelectedMembers: state => {
            const selectedItemsIds = state.selectItems.filter(item => item.selected).map(item => item.id);
            const newSelectedMembers = state.organizationMembers.filter(member => selectedItemsIds.includes(member.userSub));
            state.selectedMembers = newSelectedMembers;
        },
        setBranchItems: (state, action: PayloadAction<SelectItem[]>) => {
            state.branchItems = action.payload;
        },
        resetAddEditPolicyState: () => initialState,
    },
});

export const {
    setOrganizationMembers,
    setSelectedMembers,
    resetAddEditPolicyState,
    setSelectItems,
    setInitialSelectItems,
    resetSelectItemsToInit,
    changeSelectedMembers,
    setBranchItems,
} = addEditPolicySlice.actions;

export const selectOrganizationMembers = (state: RootState) => state.addEditPolicy.organizationMembers;

export const selectSelectedMembers = (state: RootState) => state.addEditPolicy.selectedMembers;

export const selectSelectItems = (state: RootState) => state.addEditPolicy.selectItems;

export const selectInitialSelectItems = (state: RootState) => state.addEditPolicy.initialSelectItems;

export const selectBranchItems = (state: RootState) => state.addEditPolicy.branchItems;

export default addEditPolicySlice.reducer;
